import { render, staticRenderFns } from "./CourseDropdown.vue?vue&type=template&id=2a492212&"
import script from "./CourseDropdown.vue?vue&type=script&lang=ts&"
export * from "./CourseDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports